export const READY = "ready";
export const STREAMING = "streaming";
export const FINISH = "finish";
export const CANCEL = "cancel";
